var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-networks-list"},_vm._l((_vm.links),function(link){return _c('div',{staticClass:"social-networks-list__item"},[_c('a',{attrs:{"target":"_blank","href":link.url}},[_c('img',{attrs:{"src":link.icon}})])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }